/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

import DashboardIcon from '@material-ui/icons/Dashboard';

const menu = [
  {
    title: 'Dashboard',
    icon: DashboardIcon,
    to: '/',
    id: 'dashboard',
    exact: true,
  },
];

const defaultItem = {
  title: 'Dashboard',
  icon: DashboardIcon,
  to: '/',
  id: 'dashboard',
};

export { menu, defaultItem };
